import { fetchExactagCustomerData } from "./api"
import * as exactag from "@otto-ec/online-marketing/exactag"
import { ExactagData } from "@otto-ec/online-marketing/dist-lib/exactag/core/data"

export async function trackCustomerData() {
    try {
        const exactagCustomerData: ExactagData | null = await fetchExactagCustomerData()
        exactag.registerVerticalDataCallback("customerData", () => (exactagCustomerData))
    } catch (error) {
        console.error("Failed to fetch customer's exactag data:", error)
    }
}


trackCustomerData();
